import React, { useState, useEffect } from "react";

const showcaseData = [
  {
    title: "An expert facilities management team you can trust",
    description:
      "Rade integrated services Ltd is a team of trained and dedicated specialists to provide professional services across the UK.",
    link: "/services",
    buttonText: "Learn More",
  }
];

const ArticleShowcase = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % showcaseData.length);
    }, 10000);
    return () => clearTimeout(timer);
  }, [currentIndex]);

  const { title, description,  } = showcaseData[currentIndex];

  return (
    <div className="showcase" key={currentIndex}>
      <h1>{title}</h1>
      <p>{description}</p>
    </div>
  );
};

export default ArticleShowcase;
